export const getMyColor = (): string => {
    const n = (Math.random() * 0xfffff * 1000000).toString(16);
    return `#${n.slice(0, 6)}`;
};

export function unescape(str: string): string {
    if (!str) return '';

    return str
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#x27;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&#x2F;/g, '/')
        .replace(/&#x5C;/g, '\\')
        .replace(/&#96;/g, '`');
}

export function getDisplayName(firstName: string, lastName: string, email: string): string {
    if (firstName && lastName) {
        return [firstName, lastName].filter(Boolean).join(' ');
    }

    return firstName || lastName || email;
}

export const isRecaptchaVerificationFailed = (errorCode) => {
    return errorCode && errorCode === 'RECAPTCHA_VERIFICATION_FAILD';
};
